module.exports = __webpack_public_path__ + "static/media/pricetag-alt.e5071577.svg";